import { Model } from "@vuex-orm/core";
import config from "../configs/RecipientMeetingDoc";

export default class RecipientMeetingDoc extends Model {
  static get entity() {
    return "recipientMeetingDocs";
  }
  static fields() {
    return {
      id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
      meeting: this.attr(null),
      recipient: this.attr(null),
      merged_pv_media: this.attr(null),
      agency_preferred_broadcast: this.attr(null),
      docs_status: this.attr(null),
      doc_requests: this.attr(null),
      agency_id: this.attr(null),
      mandate_id: this.attr(null),
      meeting_id: this.attr(null),
      recipient_id: this.attr(null),
      agency_preferred_invitation_broadcast: this.attr(null),
      merged_invitation_media: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
